export const GOODS_DELIVERY_NOTE = {
    BASE_PATH: '/goods-request/goods-delivery-note/',
    GET_ALL: 'goods-request/goods-delivery-note',
    GET_ONE: 'goods-request/goods-delivery-note/edit/',
    UPDATE: 'goods-request/goods-delivery-note/update/',
    DELETE: 'goods-request/goods-delivery-note/delete/',
};
